import styled from 'styled-components';
import SearchInputComponent from '@/components/SearchInput';

export const TableContainer = styled.div`
  & > div {
    border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  }

  & table {
    width: 100%;
    border: 0 none;

    td {
      vertical-align: top;
    }

    & th:first-child,
    & td:first-child {
      border-left: 0 none;
    }

    & th:last-child,
    & td:last-child {
      border-right: 0 none;
    }

    & th {
      border-top: 0 none;
    }

    & tr:last-child td {
      border-bottom: 0 none;
    }
  }
`;

export const Search = styled(SearchInputComponent)`
  min-width: 260px;
`;

export const AddNew = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors['tertiary-60']};

  svg {
    fill: #fff;
  }
`;
